import React from "react";
import { Button, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ChangePasswordButton = () => {
  const navigate = useNavigate();

  return (
    <Box textAlign="left" mt={1}>
      <Typography variant="body2" color="text.secondary" mb={1}>
        Want to update your password?
      </Typography>
      <Button variant="outlined" onClick={() => navigate("/forgot-password")}>
        Change Password
      </Button>
    </Box>
  );
};

export default ChangePasswordButton;
